import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import milestone1 from "../../../Assets/service11.jpeg"
import milestone2 from "../../../Assets/2. Course, Program, or University Selection Advice – Make the Right Choice.png"
import milestone3 from "../../../Assets/3. Admission Application Processing – Stress-Free Applications.png"
import milestone4 from "../../../Assets/4. Financial Aid & Scholarship Applications – Funding Your Dream.png"
import milestone5 from "../../../Assets/5. Pre-Departure Orientation – Be Ready for the Journey.png"
import milestone6 from "../../../Assets/6. Travel & Forex Assistance – Smooth International Transition.png"
import milestone7 from "../../../Assets/7. Post-Departure Assistance – Support Beyond Borders.png"
import milestone8 from "../../../Assets/Post-Arrival-Assistance-Services.jpg"
import milestone9 from "../../../Assets/Education-Loan-Assistance.jpg"
import milestone10 from "../../../Assets/Flight-Ticket-Booking-Forex-and-Insurance.jpg"
import './MilestoneSection.css'

const milestones = [
  {
    title: 'University/Country/Course selection',
    path: '/services/university-country-course-selection',
    content: {
      img: milestone1,
      heading: 'Abroad Education Guidance & Course Selection',
      text: <>
        Choosing the right university, country, and course is the foundation of your academic journey. Our abroad education guidance helps you make informed decisions aligned with your long-term goals.<br/><br/>
        Through career counseling and profile evaluation, we analyze your academic background, interests, and aspirations to recommend the best options.<br/><br/>
        This ensures your <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>study abroad application</Link> is strong, strategic, and aligned with future career success.
      </>
    }
  },
  {
    title: 'Career Counselling & Profile Evaluation',
    path: '/services/career-counselling-and-profile-evaluation',
    content: {
      img: milestone2,
      heading: 'Career Counseling and Profile Evaluation',
      text: <>
        Our career counseling and profile evaluation services help you identify the best academic and career path based on your strengths.<br/><br/>
        We assess academics, extracurriculars, and achievements to strengthen your study abroad application and improve admission chances.<br/><br/>
        With expert guidance, you gain clarity, confidence, and a clear roadmap for your future.
      </>
    }
  },
  {
    title: 'Test Preparation - IELTS / GRE / GMAT / TOEFL / PTE/ SAT',
    path: '/services/test-preparation',
    content: {
      img: milestone3,
      heading: 'Test Preparation Services',
      text: <>
        Our test preparation services help you achieve high scores in IELTS, GRE, TOEFL, PTE, and SAT required for your study abroad application.<br/><br/>
        With structured coaching, mock tests, and expert trainers, we ensure you improve your performance in all sections.<br/><br/>
        This strengthens your profile and increases your chances of getting into top universities.
      </>
    }
  },
  {
    title: 'Application Submission',
    path: '/services/application-submission',
    content: {
      img: milestone4,
      heading: 'Study Abroad Application Support',
      text: <>
        We provide complete support for your study abroad application, ensuring accurate and timely submission.<br/><br/>
        From SOPs and LORs to document preparation, our <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>abroad education guidance</Link> ensures your application stands out.<br/><br/>
        This reduces stress and improves your chances of admission success.
      </>
    }
  },
  {
    title: 'Visa Counseling',
    path: '/services/visa-counseling',
    content: {
      img: milestone5,
      heading: 'Student Visa Counselling & Visa Expert Support',
      text: <>
        Our <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>student visa counselling</Link> and visa counseling services ensure a smooth visa process.<br/><br/>
        As experienced visa consultants and visa experts, we guide you through documentation, requirements, and interviews.<br/><br/>
        This ensures successful visa approval and a hassle-free experience.
      </>
    }
  },
  {
    title: 'Pre Departure Briefing',
    path: '/services/pre-departure-briefing',
    content: {
      img: milestone6,
      heading: 'Pre-Departure Briefing for Students',
      text: <>
        Our <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>pre-departure briefing for students</Link> prepares you for life abroad, including culture, academics, and daily living.<br/><br/>
        We guide you on travel, accommodation, safety, and university expectations.<br/><br/>
        This ensures a smooth and confident transition to your new country.
      </>
    }
  },
  {
    title: 'Post Arrival Assistance & Services',
    path: '/services/post-arrival-assistance-and-services',
    content: {
      img: milestone7,
      heading: 'Post-Arrival Assistance for International Students',
      text: <>
        Our <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>post-arrival assistance for international students</Link> helps you settle comfortably in your destination.<br/><br/>
        We assist with accommodation, registration, and part-time job guidance.<br/><br/>
        Continuous support ensures a smooth and stress-free experience abroad.
      </>
    }
  },
  {
    title: 'Assistance in Accommodation',
    path: '/services/assistance-in-accommodation',
    content: {
      img: milestone8,
      heading: 'Accommodation Support for Students Abroad',
      text: <>
        We help you find safe and affordable accommodation based on your preferences and budget.<br/><br/>
        Options include dormitories, shared apartments, and private housing.<br/><br/>
        This ensures comfort and convenience throughout your study abroad journey.
      </>
    }
  },
  {
    title: 'Education Loan Assistance',
    path: '/services/education-loan-assistance',
    content: {
      img: milestone9,
      heading: 'Education Loan for Study Abroad',
      text: <>
        We provide complete assistance for securing an education loan for study abroad.<br/><br/>
        Our experts guide you through eligibility, documentation, and loan approval processes.<br/><br/>
        This ensures your education plans are not affected by financial constraints.
      </>
    }
  },
  {
    title: 'Flight Ticket Booking, Forex and Insurance',
    path: '/services/flight-ticket-booking-forex-and-insurance',
    content: {
      img: milestone10,
      heading: 'Travel, Forex & Insurance Support',
      text: <>
        We assist with flight booking, forex services, and travel insurance for students.<br/><br/>
        Our services ensure safe, affordable, and smooth travel to your study destination.<br/><br/>
        This completes your journey with full support from departure to arrival.
      </>
    }
  }
];

const MilestoneSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentIndex = milestones.findIndex(m => m.path === location.pathname);
    if (currentIndex !== -1) {
      setActiveIndex(currentIndex);
      setTimeout(() => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [location.pathname]);

  const toggleAccordion = (index) => {
    const isOpen = index === activeIndex;
    setActiveIndex(isOpen ? null : index);
    navigate(milestones[index].path);
  };

  return (
    <div className="milestone-container container" ref={sectionRef}>
      {milestones.map((item, index) => (
        <div key={index}>
          <div
            className={`milestone-category ${activeIndex === index ? 'active-header' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <span className="milestone-title">{index + 1}. {item.title}</span>
            <span className="dropdown-icon">
              {activeIndex === index ? '▴' : '▾'}
            </span>
          </div>

          {activeIndex === index && (
            <div className="milestone-content">
              <div className='row'>
                <div className='col-md-4'>
                  <img src={item.content.img} alt={item.title} className="milestone-image width" />
                </div>
                <div className='col-md-6'>
                  <h3 className="milestone-heading">{item.content.heading}</h3>
                  <p className="milestone-text mt-5">{item.content.text}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MilestoneSection;